<template>
    <div class="QHImgList">
        <div class="li" v-for="(item, index) in list" v-bind:key="index" @click="$openImg(item.url, item.name)">
            <Tooltip :content="item.name" placement="top">
                <img :src="$httpImg(item.url)">
            </Tooltip>
        </div>
    </div>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            values: [],
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        list: {
            type: [Array, String],
            default: ""
        },
        isLook: {
            type: Boolean,
            default: true
        },
        isRemove: {
            type: Boolean,
            default: true
        }
    }
}
</script>
<style>
.QHImgList {
    display: inline-block;
}

.QHImgList .li {
    width: 90px;
    height: 90px;
    float: left;
    background: #eee;
    margin-right: 10px;
}

.QHImgList .li img {
    cursor: pointer;
    display: block;
    width: 90px;
    height: 90px;
}
</style>